import { useEffect } from 'react'
import { isEmpty } from 'lodash'
import smoothscroll from 'smoothscroll-polyfill'

const useScrollToAddedSection = (
  sectionRefs,
  sections,
  indexToRemove,
  initialSections
) => {
  useEffect(() => {
    const lastSettingAdded =
      sectionRefs.current[sectionRefs.current.length - 1]

    sectionRefs.current.filter((section) => !isEmpty(section))

    if (initialSections.length === sections.length) {
      return
    }

    if (
      sectionRefs.current.length > 1 &&
      !isEmpty(lastSettingAdded)
    ) {
      smoothscroll.polyfill()
      lastSettingAdded.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      })
    }
  }, [sectionRefs.current.length, sections.length])

  const removeSectionFromSectionsRefs = () =>
    sectionRefs.current.splice(indexToRemove, 1)

  return { removeSectionFromSectionsRefs }
}

export default useScrollToAddedSection
